import styled from "styled-components"

export default {
    "Content": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;

        & > p {
            ${({ theme }) => theme.font["small-medium"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,
}